<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'TechCategoryCenter',
            to: {
              name: 'TechCategoryCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'TechCategoryEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改技術類別</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 技術類別 -->
    <TechCategoryCreateEdit></TechCategoryCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TechCategoryCreateEdit from '@/views/E-8__TechCategory/c/TechCategoryCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    TechCategoryCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('technologycategory', ['technologycategory']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getTechCategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('technologycategory', {
      getTechCategory: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'TechCategoryCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.technologycategory.title) {
            this.errors.push('標題 required.');
          } else if (!this.technologycategory.slug) {
            this.errors.push('Slug required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.technologycategory).then(() => {
            this.$router.push({ name: 'TechCategoryCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
